<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import DialogV from '@/comps-sdk/components/dialog-v';
  import Modal from '@/comps-sdk/components/modal';
  import { getGameDetail } from '@/comps-sdk/components/zone-role-select/services';
  import ZoneRoleContent from '@/comps-sdk/components/zone-role-select/src/views/pc/zone-role-content.svelte';
  import { GAME_TYPE, LOGIN_TYPE } from '@/comps-sdk/constants';
  import { ECommon, type IZoneRoleSelect } from '@/comps-sdk/interface';
  import bridge from '@/comps-sdk/modules/bridge';

  export let props: IZoneRoleSelect.ZoneRoleSelectProps;

  let visible = false;
  let zoneRoleContent: any;
  const { gameId, scene } = props;
  const okButtonProps = {
    props: {
      disabled: false,
    },
  };
  const dispatch = createEventDispatcher();

  const handleConfirm = () => {
    visible = false;
    const selectedValue = zoneRoleContent?.getSelectedValue();

    if (!selectedValue.role.id) {
      console.log('暂无角色，请创建角色');
      return;
    }

    const {
      area: { channel_id: area, id: partition },
      client: { id: plat },
      role: { id: roleId },
    } = selectedValue;

    const resParams = {
      role_id: roleId,
      area,
      partition,
      plat: plat === 'android' ? '1' : '0',
    };

    if (props.gameType === GAME_TYPE.client) {
      resParams.plat = '1';
      resParams.area = '-1';
    }

    props.confirmCb?.(resParams);
    dispatch('confirm', resParams);
  };

  const handleClose = () => {
    visible = false;
    props.closeCb?.();
    dispatch('close');
  };

  const handleConfirmStatusChange = (event: any) => {
    okButtonProps.props.disabled = event.detail;
  };

  // 游戏类型为端游且登录态为wx则提示用QQ登录,有微信appid的端游即支持微信
  const isGameTypeOk = async () => {
    if (`${props.gameType}` === GAME_TYPE.client && !props.hasWxAppid) {
      const { result: mainLoginType } = await bridge.getMainLoginType();

      if (!mainLoginType) {
        DialogV({
          title: '提示',
          message: '请先登录后再操作～',
          confirmButtonText: '知道啦',
          showCancelButton: false,
        });
        handleClose();
        return;
      }

      if (mainLoginType !== LOGIN_TYPE.qq) {
        DialogV({
          title: '提示',
          message: '当前游戏不支持微信哦，请更换QQ账号',
          confirmButtonText: '知道啦',
          showCancelButton: false,
        });
        handleClose();
        return;
      }
    }
    visible = true;
  };

  if (scene === ECommon.Scene.IWAN) {
    getGameDetail(gameId).then(async (gameDetail) => {
      props.gameType = `${gameDetail?.game_base_info?.game_type}` || '';
      const wxAppid = gameDetail?.game_base_info?.wx_appid;
      props.hasWxAppid = !!wxAppid;
      console.log('PC区服组件', '游戏详情:', {
        gameType: props.gameType,
        hasWxAppid: props.hasWxAppid,
      });
      isGameTypeOk();
    });
  } else {
    isGameTypeOk();
  }
</script>

{#if visible}
  <Modal title="选择角色" {okButtonProps} on:cancel={handleClose} on:ok={handleConfirm}>
    <ZoneRoleContent bind:this={zoneRoleContent} {props} on:confirm-status-change={handleConfirmStatusChange} />
  </Modal>
{/if}
